import { lazy } from "react";

export { REQUESTS_BUSINESS_TRIP_PATH } from "./business-trip-requests-path";
export const BusinessTripRequestsPage = lazy(
  () => import("./business-trip-requests"),
);
